import { connect } from 'react-redux';
import { compose, withProps } from 'react-recompose';
import Address from './Address';
import config from '../../../config';
import type { BillingAddressFlaggedProps as FlaggedProps } from './Address';
import { isLoadingSelector } from '../../../modules/LoadingStatus';
import { billingAddressSelector } from '../../../modules/Customer/selectors';

const mapStateToProps = state => ({
  isLoading: isLoadingSelector(state, 'confirmDeliveryAddress'),
  address: billingAddressSelector(state),
});

const withFlaggedProps = (): FlaggedProps => ({
  displayFullName: config.askPersonalInformationDuringOrderSim,
  inferStateOrProvinceFromPostCode: config.inferAddressStateOrProvinceFromPostCode,
  isFullNameDisabled: false,
  displayHouseNumber: config.displayHouseNumber,
});

const enhance = compose(connect(mapStateToProps), withProps(withFlaggedProps));
export default enhance(Address);
